import * as React from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "outline";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
};

export function Button({
  variant = "primary",
  className,
  ...props
}: ButtonProps) {
  const base =
    "inline-flex cursor-pointer items-center justify-center rounded-md px-4 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

  const variants: Record<ButtonVariant, string> = {
    primary:
      "bg-rose-600 text-white hover:bg-rose-700 focus-visible:ring-rose-600 ring-offset-white",
    secondary:
      "border border-gray-200 bg-white text-gray-900 hover:bg-gray-50 focus-visible:ring-gray-300 ring-offset-white",
    ghost:
      "bg-transparent text-gray-900 hover:bg-gray-100 focus-visible:ring-gray-300 ring-offset-white",
    outline:
      "border border-rose-600 bg-transparent text-rose-600 hover:bg-rose-50 focus-visible:ring-rose-600 ring-offset-white",
  };

  return (
    <button
      className={[base, variants[variant], className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}
